import { Button } from 'component/Button'
import { ProfileOptions } from 'component/ProfileOptions'
import { Gap } from 'component/Space/Gap'
import { Vertical } from 'component/Vertical'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { opt } from 'store/opt'
import { store } from 'store/store'

export const PhotoView = observer(() => {
  const data_management = false // !me.external && !opt.stand

  const onData = useLatestCallback(async () => {
    store.profile.step = 'data'
  })

  return (
    <Vertical>
      <Gap spring />
      <ProfileOptions />
      <Gap height={24} />

      {data_management && <Gap height={8} />}
      {data_management && (
        <Button link={!opt.tsum} large={opt.tsum} action={onData}>
          {i18n('UserDataManagement')}
        </Button>
      )}
    </Vertical>
  )
})
